<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="80px">
          <el-row :gutter="24" type="flex">
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compNames">
                <div class="customer-input-wrap">
                  <el-input v-model="queryParams.compNames" placeholder="请输入客户名称"  @keyup.enter.native="handleQuery" />
                  <CustomerDetails v-model="queryParams.compNames" />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人" prop="contactPerson">
                <el-input v-model="queryParams.contactPerson" placeholder="请输入联系人" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户状态" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择客户状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value="-1"></el-option>
                  <el-option label="进行中" value="1"></el-option>
                  <el-option label="完结" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24" type="flex">
           
          </el-row> -->
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleAdd="handleAdd" @handleImport="handleImport" @handleExport="handleExport" />
          </div>
          <el-table id="customerTable" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    v-loading="loading" row-key="id" height="500">
            <el-table-column type="index" label="序号" width="55" fixed="left" align="center"></el-table-column>
            <el-table-column label="编号" align="left" prop="customerCode" min-width="120" show-overflow-tooltip fixed="left"></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip fixed="left"></el-table-column>
            <el-table-column label="联系人" align="left" prop="contactPerson" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="联系电话" align="left" prop="contactPhone" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="开票主体" align="left" prop="invoiceEntity" min-width="260" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="left" prop="status" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="返点方案" align="left" prop="rebatePlan" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="返点具体方案" align="left" prop="rebateInfo" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="跟单员" align="left" prop="followUpPerson" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="项目来源" align="left" prop="projectSource" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center" width="180" fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100,200,500]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入新增/修改弹窗组件 -->
    <AddEdit ref="addEdit" @refresh="getList" />

    <!-- 导入对话框 -->
    <el-dialog title="导入客户数据" :visible.sync="importDialogVisible" width="500px" :close-on-click-modal="false">
      <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="handleFileChange" :file-list="fileList" :limit="1" accept=".xlsx,.xls">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 Excel 文件，且不超过 10MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitImport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddEdit from './addEdit.vue';
// TODO: 导入API方法
import {
  queryCustBaseList, //客户管理功能列表分页查询
  saveCustBase,   //客户管理功能保存
  queryCustBaseDetail, //客户管理功能查询详情
  updateCustBase, //客户管理功能修改
  deleteCustInfo, //客户管理功能删除
  importCustBase, //客户管理功能导入
  exportCustBase //客户管理功能导出
} from '@/api/contract/contract';
export default {
  name: 'CustomerManagement',
  components: {
    AddEdit
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        compNames: undefined,
        contactPerson: undefined,
        status: '-1' // 默认全部
      },
      // 导入对话框
      importDialogVisible: false,
      fileList: []
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 获取状态文本
    getStatusText (status) {
      const s = Number(status);
      switch (s) {
        case 1:
          return '进行中';
        case 0:
          return '完结';
        default:
          return '未知';
      }
    },

    // 查询列表
    getList () {
      this.loading = true;

      // 状态筛选：页面值直接传给后端（-1/0/1）
      const statusVal = this.queryParams.status;
      const enabledState = Number(statusVal);

      // 仅提交页面存在且有对应后端字段的筛选条件
      const payload = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
        compNames: this.queryParams.compNames,
        contactPerson: this.queryParams.contactPerson,
        enabledState: enabledState
      };

      queryCustBaseList(payload).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          // 将后端字段映射为表格展示字段
          this.tableData = records.map((item, index) => {
            return {
              // 保留原始数据，便于删除/编辑时整行传参
              ...item,
              id: item.id || item.custPid || index,
              customerCode: item.compCode || '', // 编号
              compName: item.compName || '',
              contactPerson: item.contactPerson || '',
              contactPhone: item.contactTel || '',
              followUpPerson: item.followPerson || '',
              projectSource: item.projectSource || '',
              invoiceEntity: item.compEntityName || '',
              status: item.enabledState === 1 ? 1 : 0, // 1进行中，其余(0/2)视为完结
              rebatePlan: item.rebateTypeStr || ''  // 直接使用后端返回的返点方案名称
            };
          });
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取客户列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取客户列表失败:', error);
        this.loading = false;
        this.$message.error('获取客户列表失败');
      });
    },
    // 搜索按钮
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 新增按钮
    handleAdd () {
      this.$refs.addEdit.openDialog('Add');
    },
    // 修改按钮
    handleEdit (row) {
      // 可按需拉取详情，当前先直接将行数据传入
      this.$refs.addEdit.openDialog('Edit', row);
    },
    // 删除按钮
    handleDelete (row) {
      this.$confirm('确定删除该客户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustInfo(row.compCode).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('删除成功');
            this.getList();
          } else {
            this.$message.error((res && res.retMsg) || '删除失败');
          }
        }).catch(error => {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 导入按钮
    handleImport () {
      this.importDialogVisible = true;
      this.fileList = [];
    },
    // 文件选择改变
    handleFileChange (file, fileList) {
      this.fileList = fileList;
    },
    // 提交导入
    submitImport () {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);

      // 调用导入API
      importCustBase(formData).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success('导入成功');
          this.importDialogVisible = false;
          this.fileList = [];
          this.getList();
        } else {
          this.$message.error((res && res.retMsg) || '导入失败');
        }
      }).catch(error => {
        console.error('导入失败:', error);
        this.$message.error('导入失败：' + (error.message || '未知错误'));
      });
    },
    // 导出按钮
    handleExport () {
      this.$message.info('正在导出客户数据...');

      // 准备导出参数（使用当前查询条件）
      const exportStatusVal = this.queryParams.status;
      const exportEnabledState = Number(exportStatusVal);

      const exportParams = {
        compName: this.queryParams.compNames,
        contactPerson: this.queryParams.contactPerson,
        enabledState: exportEnabledState
      };

      // 调用导出API
      exportCustBase(exportParams).then(response => {
        // 处理文件下载
        // 由于设置了 responseType: 'blob'，response 应该是 Blob 对象
        // 但如果响应拦截器处理过，可能是 response.data
        let blob;
        if (response instanceof Blob) {
          blob = response;
        } else if (response && response.data instanceof Blob) {
          blob = response.data;
        } else {
          // 如果不是 blob，尝试转换为 blob
          blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
        }

        // 检查是否是错误响应（后端可能返回错误信息的 JSON，但被解析为 blob）
        if (blob.type && blob.type.includes('application/json')) {
          // 如果是 JSON 错误响应，读取内容并提示
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result);
              this.$message.error(errorData.retMsg || errorData.message || '导出失败');
            } catch (e) {
              this.$message.error('导出失败');
            }
          };
          reader.readAsText(blob);
          return;
        }

        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = `客户数据_${new Date().getTime()}.xlsx`;

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功');
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败：' + (error.message || '未知错误'));
      });
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.upload-demo {
  text-align: center;
}

.el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}

::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>

